<template>
  <div class="content-page">
    <div class="main-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox">
        <div class="star-title">
          <span class="star"></span>如何网上申请?
        </div>
        <div class = "contentBox how-contentBox">
            <div class="textBox">
              <el-steps direction="vertical" :active="stepList.length + 1 " >
                <el-step v-for="(item, index) in stepList" :key="index" :title="item.content"></el-step>
              </el-steps>
            </div>
        </div>
        <!-- <div class="consult-text" >还没明白，我要咨询 <i class="el-icon-chat-line-round"></i> </div> -->
        <div class="btnLists">
          <div class="primary-btn" @click="handleNext" > 下一步 </div>
          <div class="border-btn" style="marginLeft:20px" @click="$router.push('/matterTip')" >返回上一页</div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      stepList: []
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  created () {
    // 初始化登录状态
    this.initLoginStatus()
    this.getDescribeTex()
  },
  methods: {
    ...mapActions(['initLoginStatus']),
    getDescribeTex () {
      Api.getDescribeTex({ type: 'step' }).then(res => {
        this.stepList = res.data.data
      })
    },
    // 下一步按钮点击事件
    handleNext () {
      // 如果已登录，跳转到选择申请类型页面
      if (this.isLogin) {
        this.$router.push('/selectType')
      } else {
        // 如果未登录，跳转到注册页面
        this.$router.push('/register')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 1000px) {
    .main-contentBox{
      padding: 15px 20px 15px !important;
    }
  }
.main-contentBox{
  width: 100%;
   padding: 60px 135px 80px;
  .how-contentBox{
    overflow: auto;
    height: 314px;
    margin-top: 50px;
  }
  .textBox{
    height: 240px;
     ::v-deep.el-step{
      .el-step__main{
        .el-step__title{
        color: #333;
        }
      }
    }
  }
  .consult-text{
    margin-top: 20px;
    margin-bottom: 50px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FE3535;
    i{
      font-size: 14px;
    }
  }
}
</style>
